/** @format */

import { z } from "zod";

export const resetPasswordConfirmSchema = z
  .object({
    password1: z.string().min(8, "Password must be at least 8 characters"),
    password2: z.string().min(8, "Password must be at least 8 characters"),
  })
  .refine(data => data.password1 === data.password2, {
    message: "Passwords must match",
    path: ["password2"],
  });

export type ResetPasswordConfirmFormData = z.infer<typeof resetPasswordConfirmSchema>;
